import { Fragment } from '@atlaskit/editor-prosemirror/model';
import { findParentNodeOfType, findSelectedNodeOfType } from '@atlaskit/editor-prosemirror/utils';
import { getDefaultSyncBlockSchema } from '@atlaskit/editor-synced-block-provider';
import { CellSelection, findTable } from '@atlaskit/editor-tables';
export var findSyncBlock = function findSyncBlock(state, selection) {
  var syncBlock = state.schema.nodes.syncBlock;
  return findSelectedNodeOfType(syncBlock)(selection || state.selection);
};
export var findBodiedSyncBlock = function findBodiedSyncBlock(state, selection) {
  var bodiedSyncBlock = state.schema.nodes.bodiedSyncBlock;
  return findSelectedNodeOfType(bodiedSyncBlock)(selection || state.selection) || findParentNodeOfType(bodiedSyncBlock)(selection || state.selection);
};
export var findSyncBlockOrBodiedSyncBlock = function findSyncBlockOrBodiedSyncBlock(state, selection) {
  return findSyncBlock(state, selection) || findBodiedSyncBlock(state, selection);
};
export var isBodiedSyncBlockNode = function isBodiedSyncBlockNode(node, bodiedSyncBlock) {
  return node.type === bodiedSyncBlock;
};
export var canBeConvertedToSyncBlock = function canBeConvertedToSyncBlock(selection) {
  var from = selection.from;
  var to = selection.to;
  var depth = selection.$from.depth;
  var contentToInclude;
  if (selection instanceof CellSelection) {
    var table = findTable(selection);
    if (!table) {
      return false;
    }
    contentToInclude = Fragment.from([table.node]);
    from = table.pos;
    to = table.pos + table.node.nodeSize;
    depth = selection.$from.doc.resolve(table.pos).depth;
  } else {
    contentToInclude = Fragment.from(selection.content().content);
  }

  // sync blocks can't be nested
  if (depth > 1) {
    return false;
  }
  var syncBlockSchema = getDefaultSyncBlockSchema();
  var canBeConverted = true;
  selection.$from.doc.nodesBetween(from, to, function (node) {
    if (!(node.type.name in syncBlockSchema.nodes)) {
      canBeConverted = false;
      return false;
    }
    node.marks.forEach(function (mark) {
      if (!(mark.type.name in syncBlockSchema.marks)) {
        canBeConverted = false;
        return false;
      }
    });
  });
  if (!canBeConverted) {
    return false;
  }
  return {
    contentToInclude: contentToInclude,
    from: from,
    to: to
  };
};